import {getProductDetailDisplayPrice, clareProductToProduct} from './product';
import {Product} from './product';

/*
 * Session-backed price when finance GETs omit variations/pricing. Delete this module and call sites
 * (CreateProductService, ProductDetailStore, mapListViewItemToProductWithPending) once
 * GET /finance/products/:id (and/or …/variations) consistently returns default variation price.
 */

const SESSION_KEY_PREFIX = 'pm-pending-price-';

/** Persists display price after create so detail/list can read it when the API omits variation pricing. */
export function persistPendingProductPriceFromCreate(product: Product): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  const id = product.id;
  const price = product.price;
  if (id === null || id === undefined || price === undefined || price === null || Number.isNaN(Number(price))) {
    return;
  }
  sessionStorage.setItem(`${SESSION_KEY_PREFIX}${id}`, String(price));
}

/**
 * Applies a pending create price to `item.price` when the API returns no resolvable price.
 * The key stays until the API returns a real price (then it is cleared). `getProductDetailDisplayPrice` uses `item.price` as a fallback.
 */
export function applyPendingProductPriceFromSession(item: Product): Product {
  let result: Product = item;
  if (typeof sessionStorage !== 'undefined') {
    const fromApi = getProductDetailDisplayPrice(item);
    const key = item.id !== undefined ? `${SESSION_KEY_PREFIX}${item.id}` : null;
    if (fromApi > 0 && key !== null && sessionStorage.getItem(key) !== null) {
      sessionStorage.removeItem(key);
    }
    if (fromApi === 0 && item.id !== undefined) {
      const raw = sessionStorage.getItem(`${SESSION_KEY_PREFIX}${item.id}`);
      if (raw !== null) {
        const pending = Number(raw);
        if (!Number.isNaN(pending)) {
          result = {...item, price: pending};
        }
      }
    }
  }
  return result;
}

/** List rows: same pending price as product detail when the list payload has no variation pricing. */
export function mapListViewItemToProductWithPending(item: Product): Product {
  return clareProductToProduct(applyPendingProductPriceFromSession(item));
}
